import React from 'react';
import { DatePicker } from 'antd';

import type { RangePickerProps as AntdRangePickerProps } from 'antd/es/date-picker';

import styles from './DateRangePicker.module.scss';

const { RangePicker } = DatePicker;

const DateRangerPicker = React.forwardRef<any, AntdRangePickerProps>(({ onChange, maxDate, value, ...restProps }, ref) => {
  const [selectedDateRange, setSelectedDateRange] = React.useState<any>(value);

  // Update internal state when external value prop changes
  React.useEffect(() => {
    setSelectedDateRange(value);
  }, [value]);

  React.useImperativeHandle(ref, () => ({
    clear: () => {
      setSelectedDateRange(null);
    }
  }));

  const handleOnChange = (value: any, option: any) => {
    setSelectedDateRange(value);

    if (onChange) {
      onChange(value, option);
    }
  }

  return (
    <div className={styles.customRangePicker}>
      <RangePicker
        allowClear
        className='custom-range-picker'
        onChange={handleOnChange}
        maxDate={maxDate} 
        value={selectedDateRange}
        {...restProps}
      />
    </div>
      
  )
});

export default DateRangerPicker;